import { render } from "./video.vue?vue&type=template&id=3b9e37a6"
import script from "./video.vue?vue&type=script&lang=js"
export * from "./video.vue?vue&type=script&lang=js"

import "./video.vue?vue&type=style&index=0&id=3b9e37a6&lang=scss"
script.render = render

export default script